import styled from 'styled-components';
import { CFBaseModalBottomSheetStyles, CFStyleThemes, } from '@connectrn/ds-ui-base';
export const CFModalBottomSheetElements = {
    Body: styled.div `
    ${CFBaseModalBottomSheetStyles.Body}
  `,
    Footer: styled.div `
    ${CFBaseModalBottomSheetStyles.Footer}
  `,
    Header: styled.div `
    ${CFBaseModalBottomSheetStyles.Header}
  `,
    Root: styled.dialog `
    ${CFBaseModalBottomSheetStyles.Root};
    ${CFBaseModalBottomSheetStyles.RootWeb};
  `,
    Sheet: styled.div `
    ${CFBaseModalBottomSheetStyles.Sheet}
  `,
};
CFModalBottomSheetElements.Sheet.defaultProps = {
    theme: CFStyleThemes.DEFAULT,
};
